import React, {
	useState,
	Fragment as Frag
} from 'react';
import PropTypes from 'prop-types';
import {TextBlock} from 'react-placeholder/lib/placeholders';
import ReactPlaceholder from 'react-placeholder';

import {
	makeStyles,
	Button
} from '@material-ui/core';

import Constants from "../utils/Constants";
import PostMap from "./PostMap";
import Associations from "./Associations";

const styles = makeStyles(theme => ({
	bottomPad: {
		paddingBottom: theme.spacing(2)
	},

	viewDetails: {
		marginTop: theme.spacing(1),
		marginLeft: theme.spacing(-1)
	},

	map: {
		marginTop: theme.spacing(1)
	}
}));

const placeholderColor = Constants.COLORS.PLACEHOLDER_BG;
const placeHolder = (
	<TextBlock rows={2} color={placeholderColor}><span></span></TextBlock>
);

function AssociationsPanel(props) {
	const [expand, setExpand] = useState(false);

	let classes = styles(),
		btnAdded = false,
		{associations, twitterRedacted, category, history} = props,
		ready = associations ? associations.length > 0 : false;

	return (
		<Frag>
			{associations && associations.length && ready ?
				<React.Fragment>
					{associations.map((association, idx) => {
						btnAdded = idx > 0;
						return (
							association.component === 'associations' ? (
								<Frag key={idx}>
									<Associations
										expand={expand}
										content={association.content} />
									{!btnAdded ?
										<Button
											color="primary"
											onClick={() => setExpand(!expand)}
											className={classes.viewDetails}>{expand ? "Hide" : "View"} Details</Button> : null
									}
								</Frag>
							) : association.component === 'postmap' ? (
								<PostMap
									key={idx}
									history={history}
									association={association}
									twitterRedacted={twitterRedacted}
									category={category}
									className={classes.map} />
							) : null
						);
					})}
				</React.Fragment> : null
			}
			<ReactPlaceholder ready={ready} customPlaceholder={placeHolder}><span></span></ReactPlaceholder>
		</Frag>
	);
}

AssociationsPanel.propTypes = {
	history: PropTypes.object.isRequired,
	associations: PropTypes.array,
	twitterRedacted: PropTypes.string,
	category: PropTypes.number
};

export default AssociationsPanel;